<template>
  <div>
    <div class="vx-row" id="formulation_manufacturing_and_financial_form">
      <div class="vx-col w-full">
        <vx-card no-shadow>
          <template slot="actions">
            <vs-button v-if="$canAny(formulationMfPermissions)" @click="onClickSave()" class="mr-0" color="primary" size="small"
                       type="filled">Save Changes
            </vs-button>
          </template>

          <vx-card noShadow cardBorder  class="mb-2">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="labour_charge_per_hour" name="labour_charge_per_hour" rules=""
                                    v-slot="{ errors }">
                  <small class="label">Labour charge per hour (GBP)</small>
                  <vs-input v-model="formulation.labour_charge_per_hour" name="labour_charge_per_hour" class="w-full"
                            label="" :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" disabled/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="number_of_hours" name="number_of_hours" rules="required" v-slot="{ errors }">
                  <small class="label">Apply default labour hours per batch? ({{ work_order_default_values.number_of_hours }} H:m)</small>
                  <vs-switch v-model="formulation.is_labour_hour_default" icon-pack="feather" vs-icon-on="icon-check-circle"
                            vs-icon-off="icon-slash" class="mt-3 w-16" @input="onChangeDefaultValues(formulation.is_labour_hour_default, 'number_of_hours')">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="number_of_hours" name="number_of_hours" rules="required" v-slot="{ errors }">
                  <small class="label">Labour hours per batch (H:m)</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                              class="w-full" v-model="formulation.number_of_hours"
                              placeholder="H:m" :disabled="!$canAny(formulationMfPermissions) || formulation.is_labour_hour_default"/>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="machine_charge_per_hour" name="machine_charge_per_hour" rules=""
                                    v-slot="{ errors }">
                  <small class="label">Machine Cost per hour (GBP)</small>
                  <vs-input v-model="formulation.machine_charge_per_hour" name="machine_charge_per_hour" class="w-full"
                            label="" :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" disabled/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="number_of_hours" name="number_of_hours" rules="required" v-slot="{ errors }">
                  <small class="label">Apply default production line time allocation?  ({{ work_order_default_values.machine_number_of_hours }} H:m)</small>
                  <vs-switch v-model="formulation.is_machine_hour_default" icon-pack="feather" vs-icon-on="icon-check-circle"
                            vs-icon-off="icon-slash" class="mt-3 w-16" @input="onChangeDefaultValues(formulation.is_machine_hour_default, 'machine_number_of_hours')">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="machine_number_of_hours" name="machine_number_of_hours" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Production line time allocation (H:m)</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                              class="w-full" v-model="formulation.machine_number_of_hours"
                              placeholder="H:m" :disabled="!$canAny(formulationMfPermissions) || formulation.is_machine_hour_default"/>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="sundry_cost" name="sundry_cost" rules="required" v-slot="{ errors }">
                  <small class="label">Sundry cost per batch (GBP)</small>
                  <vs-input :value="Number(formulation.sundry_cost * finished_quantity).toFixed(2)" name="sundry_cost" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" disabled/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="number_of_hours" name="number_of_hours" rules="required" v-slot="{ errors }">
                  <small class="label">Apply default clean time? ({{ work_order_default_values.clean_time }} H:m)</small>
                  <vs-switch v-model="formulation.is_clean_hour_default" icon-pack="feather" vs-icon-on="icon-check-circle"
                            vs-icon-off="icon-slash" class="mt-3 w-16" @input="onChangeDefaultValues(formulation.is_clean_hour_default, 'clean_time')">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="clean_time" name="clean_time" rules="required" v-slot="{ errors }">
                  <small class="label">Clean Time Between Uses (H:m)</small>
                  <flat-pickr :config="{enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                              class="w-full" v-model="formulation.clean_time" :disabled="!$canAny(formulationMfPermissions) || formulation.is_clean_hour_default"
                              placeholder="H:m"/>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row mb-3" v-if="formulation.formulation_type === 'spray dry powder'">
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="sundry_cost" name="sundry_cost" rules="required" v-slot="{ errors }">
                  <small class="label">3rd party sundry cost per batch (GBP)</small>
                  <vs-input :value="Number(formulation.third_party_charge.sundry_cost).toFixed(2)" name="sundry_cost" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" disabled/>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="toll_drying_cost" name="toll_drying_cost" rules="required" v-slot="{ errors }">
                  <small class="label">Toll drying cost per batch (GBP)</small>
                  <vs-input :value="Number(formulation.third_party_charge.toll_drying_cost).toFixed(2)" name="toll_drying_cost" class="w-full" label=""
                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                            val-icon-pack="feather" disabled/>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <vx-card noShadow cardBorder  class="mb-2">
            <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="mpPerKg" name="mpPerKg" rules="" v-slot="{ errors }">
                <small class="label text-danger">Manufactured price per KG (GBP) based on batch weight in RM quantity column in items</small>
                <vs-input v-model="mpPerKg" name="mpPerKg" class="w-full" label="" :danger="!!errors[0]"
                          :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" disabled/>
              </ValidationProvider>
            </div>
          </div>
          </vx-card>
          <vx-card noShadow cardBorder  class="mb-2">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/4 w-full md:mb-0">
                <ValidationProvider vid="use_default_variance" name="use_default_variance" rules="" v-slot="{ errors }">
                  <small class="label">Apply default manufacturing variance ({{ work_order_variance_percent }}%)</small>
                  <vs-switch v-model="use_default_variance" icon-pack="feather" vs-icon-on="icon-check-circle"
                            vs-icon-off="icon-slash" class="mt-2 w-16" @input="onChangeDefaultVariance()">
                    <span slot="on">Yes</span>
                    <span slot="off">No</span>
                  </vs-switch>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider v-if="!use_default_variance" vid="manufacturing_variance" name="manufacturing_variance" rules="required|positive" v-slot="{ errors }">
                  <small class="label">Custom Manufacturing Variance (%)</small>
                  <vs-input v-model="formulation.manufacturing_variance" name="manufacturing_variance" class="w-full" label="" :danger="!!errors[0]"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <vx-card noShadow cardBorder  class="mb-2">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="min_order_quantity" name="min_order_quantity" rules="required"
                                    v-slot="{ errors }">
                  <small class="label">Min order qty</small>
                  <vs-input v-model="formulation.min_order_quantity" name="min_order_quantity" class="w-full" label=""
                            :danger="!!errors[0]" :disabled="!$canAny(formulationMfPermissions)"
                            :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
          <vx-card noShadow cardBorder  class="mb-2">
            <div class="vx-row mb-3">
              <div class="vx-col md:w-1/2 w-full md:mb-0">
                <ValidationProvider vid="manufacturing_instruction" name="manufacturing_instruction" rules="" v-slot="{ errors }">
                  <small class="label">Manufacturing Instructions</small>
                  <vs-textarea class="mb-0" v-model="formulation.manufacturing_instruction" height="150px" />
                </ValidationProvider>
              </div>
            </div>
          </vx-card>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

const FormulationsRepository = RepositoryFactory.get('formulations')
const SettingsRepository = RepositoryFactory.get('settings')

import moment from 'moment/src/moment'

export default {
  name: "FormulationManufacturingAndFinancialTab",
  data() {
    return {
      formulationId: '',
      work_order_variance_percent: 0,
      use_default_variance: true,
      work_order_default_values: {
        number_of_hours: '',
        machine_number_of_hours: '',
        clean_time: '',
      }
    }
  },
  props: {
    formulation_data: {
      type: Object,
      default: {},
    },
    formulationPermissions: {
      type: Array,
      default: [],
    }
  },
  methods: {
    async onClickSave() {
      await this.$vs.loading({
        container: '#formulation_manufacturing_and_financial_form',
        scale: 0.45
      })
      try {
        const payload = {
          min_order_quantity: this.formulation.min_order_quantity,
          number_of_hours: this.formulation.number_of_hours,
          machine_number_of_hours: this.formulation.machine_number_of_hours,
          sundry_cost: Number(this.formulation.sundry_cost).toFixed(2),
          clean_time: this.formulation.clean_time,
          // expiration_months: this.formulation.expiration_months,
          manufacturing_instruction: this.formulation.manufacturing_instruction,
          manufacturing_variance: this.use_default_variance ? null : Number(this.formulation.manufacturing_variance).toFixed(4),
          is_clean_hour_default: this.formulation.is_clean_hour_default,
          is_labour_hour_default: this.formulation.is_labour_hour_default,
          is_machine_hour_default: this.formulation.is_machine_hour_default,
        }
        await FormulationsRepository.updateFormulationManufacturingFinancial(this.formulationId, payload)
        await this.$emit('refreshGeneral', '')
        this.showSuccessMessage('Formulation Updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation_manufacturing_and_financial_form > .con-vs-loading')
    },
    async fetchDefaultManufacturingVariance() {
      try {
        const { data } = (await SettingsRepository.getTheItem('work_order_variance_percent')).data
        this.work_order_variance_percent = data.work_order_variance_percent
        
        const { data: timesList } = (await SettingsRepository.getWorkOrderTimes()).data
        const matched = timesList.find(item => item.formulation_type === this.formulation.formulation_type)
        if (matched) {
          this.work_order_default_values.number_of_hours = matched.labour_time ? matched.labour_time.substring(0, 5) : '00:00'
          this.work_order_default_values.machine_number_of_hours = matched.machine_time ? matched.machine_time.substring(0, 5) : '00:00'
          this.work_order_default_values.clean_time = matched.clean_time ? matched.clean_time.substring(0, 5) : '00:00'
        } else {
          this.work_order_default_values.number_of_hours = '00:00'
          this.work_order_default_values.machine_number_of_hours = '00:00'
          this.work_order_default_values.clean_time = '00:00'
        }
      } catch (error) {
        this.convertAndNotifyError(error);
      }
    },
    generateDefaultValues() {
        const {is_labour_hour_default, is_machine_hour_default, is_clean_hour_default} = this.formulation;
        const {number_of_hours, machine_number_of_hours, clean_time} = this.work_order_default_values;

        this.formulation.number_of_hours = is_labour_hour_default ? number_of_hours : this.formulation.number_of_hours;
        this.formulation.machine_number_of_hours = is_machine_hour_default ? machine_number_of_hours : this.formulation.machine_number_of_hours;
        this.formulation.clean_time = is_clean_hour_default ? clean_time : this.formulation.clean_time;
    },
    onChangeDefaultVariance() {
      if (this.use_default_variance) {
        this.formulation.manufacturing_variance = this.work_order_variance_percent
      }
    },
    onChangeDefaultValues(value, key) {
      if(value) {
        this.formulation[key] = this.work_order_default_values[key]
      }
    }
  },
  async mounted() {
    this.formulationId = this.$route.params.id
    await this.fetchDefaultManufacturingVariance()
    const isNullVariance = this.formulation.manufacturing_variance == null
    this.use_default_variance = isNullVariance || Number(this.formulation.manufacturing_variance) === Number(this.work_order_variance_percent)
    if (isNullVariance) {
      this.formulation.manufacturing_variance = Number(this.work_order_variance_percent).toFixed(2)
    } else {
      this.formulation.manufacturing_variance = Number(this.formulation.manufacturing_variance).toFixed(2)
    }
    this.generateDefaultValues()
  },
  computed: {
    formulation: function () {
      return this.formulation_data
    },
    effectiveVariance() {
      if (this.use_default_variance) return Number(this.work_order_variance_percent)
      return Number(this.formulation.manufacturing_variance)
    },
    mpPerKg() {
      const rmCostWithVariance = this.rmCost * (1 + this.effectiveVariance / 100)
      return Number((rmCostWithVariance + this.totalOverHeads) / this.finished_quantity).toFixed(2)
    },
    labourTotal() {
      const labour_hours_minutes = moment.duration(this.formulation.number_of_hours).asMinutes()
      const clean_time_hours_minutes = moment.duration(this.formulation.clean_time).asMinutes()
      return Number(Number(this.formulation.labour_charge_per_hour) * Number((labour_hours_minutes + clean_time_hours_minutes) / 60))
    },
    machineTotal() {
      const machine_hours_minutes = moment.duration(this.formulation.machine_number_of_hours).asMinutes()
      return Number(Number(this.formulation.machine_charge_per_hour) * Number(machine_hours_minutes / 60))
    },
    sundries() {
      return Number(this.formulation.sundry_cost) * Number(this.finished_quantity)
    },
    totalOverHeads() {
      return Number(this.labourTotal + this.machineTotal + this.sundries + (this.formulation.third_party_charge ? this.formulation.third_party_charge.sundry_cost : 0) + (this.formulation.third_party_charge ? this.formulation.third_party_charge.toll_drying_cost : 0))
    },
    rmCost() {
      const total = this.formulation.raw_material_items.reduce((acc, obj) => {
        return acc + Number(obj.is_liquid ? obj.finished_quantity : obj.quantity) * Number(obj.cost)
      }, 0)
      return Number(total)
    },
    quantity() {
      const total = this.formulation.raw_material_items.reduce((acc, obj) => {
        return acc + Number(obj.quantity)
      }, 0)
      return Number(total)
    },
    finished_quantity() {
      const total = this.formulation.raw_material_items.reduce((acc, obj) => {
        if(obj.is_liquid) {
          return acc + Number(obj.finished_quantity)
        }
        return acc + Number(obj.quantity)
      }, 0)
      return Number(total)
    },
    formulationMfPermissions: function () {
      return this.formulationPermissions.concat([ 'ops-elements-edit' ])
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
  components: {
    flatPickr,
  },
}
</script>

<style scoped>

.__table-heading-small {
  /*font-size: x-small;*/
  /*font-weight: normal;*/
}

</style>
